import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  EnvironmentConfiguration, Environments,
  environments
} from './services/environment.configuration';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
  ],
  exports: [

  ],
  providers: [
    {
      provide: Environments,
      useValue: environments,
    },
    EnvironmentConfiguration
  ]
})
export class EnvironmentModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/environment/environment.module.ts